import React, { useContext } from "react";
import { Logout, ToastMessage } from "../../../../utils/Helper";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import DeliveryPincodeDataTabelContainer from "./DeliveryPincodeDataTabelContainer";
import DeliveryPincodeCreateFormPopup from "./DeliveryPincodeCreateFormPopup";
import Breadcrumb from "../../../../reuseable/Breadcrumb/Breadcrumb";
import {
  DELIVERY_PINCODE_LIST,
  PINCODE,
  SLACE,
} from "../../../../reuseable/Breadcrumb/BreadcrumbConstant";
import Modal from "../../../../reuseableComponents/Modal";
import {
  CreateDeliveryPincode,
  UpdateDeliveryPincode,
} from "../../../../constants";
import DeliveryPincodeContext from "../../../../context/DeliveryPincodeContext/DeliveryPincodeContext";
import { get_Delivery_Pincode } from "../../../../Apis/deliveryPincodeApi/DeliveryPincodeApi";

const DeliveryPincode = () => {
  const {
    //pagination state variables
    pageSize,
    page,
    setRecord,
    sortOrder,
    sortBy,
    filter,

    //delivery pincode edit condition state and data object state
    setdialogs,
    dialog,
    setIsEdit,
    isEdit,
    setFormData,
    setErrors,
  } = useContext(DeliveryPincodeContext);

  const history = useNavigate();

  const emptyField = () => {
    setFormData({
      pincodeMasterId: null,
      isDeliveryAvailable: false,
      storeId: null,
    });
  };

  /**
   * get delivery pincode
   */

  let paramsObj = {
    pageNumber: page,
    recordsPerPage: pageSize,
    sortOrder,
    sortBy,
  };
  if (filter.length) {
    paramsObj["search"] = { pincode: filter };
  }

  let { data, refetch, isLoading, error } = useQuery(
    ["getDeliveryPincode", paramsObj],
    async () => await get_Delivery_Pincode(paramsObj),
    {
      onSuccess: (response) => {
        if (response.status === 200) {
          setRecord(response.pager.totalRecords);
        }
      },
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      keepPreviousData: true,
      refetchOnReconnect: false,
      retry: 3,
    }
  );

  if (error) {
    const { status, message } = error?.response?.data || error;
    ToastMessage(status, message);
    Logout(history, status);
  }

  /**
   * Open Popup and Close Popup delivery pincode
   */
  const handleOpenandClosePopup = (condition) => {
    setIsEdit(true);
    if (condition) {
      setdialogs(condition);
      emptyField();
      setErrors({});
    } else {
      setdialogs(condition);
      emptyField();
      setErrors({});
    }
  };
  return (
    <>
      <Breadcrumb name={PINCODE} slace={SLACE} name1={DELIVERY_PINCODE_LIST} />
      <DeliveryPincodeDataTabelContainer
        isLoading={isLoading}
        data={data}
        handleOpenandClosePopup={handleOpenandClosePopup}
        refetch={refetch}
      />
      <Modal
        hide={handleOpenandClosePopup}
        visible={dialog}
        header={isEdit ? CreateDeliveryPincode : UpdateDeliveryPincode}
        Component={
          <DeliveryPincodeCreateFormPopup
            refetch={refetch}
            emptyField={emptyField}
          />
        }
      />
    </>
  );
};

export default DeliveryPincode;
